import { Icon, IconImage } from 'bold-ui'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import React from 'react'

import { ConsultaSeguimentoPerguntaStatusLabel } from './components/ConsultaSeguimentoPerguntaStatusLabel'
import {
  ConsultaSeguimentoPerguntaStatusTag,
  ConsultaSeguimentoPerguntaStatusTagEnum,
} from './components/ConsultaSeguimentoPerguntaStatusTag'
import { ConsultaSeguimentoStatusRespondendoIcon } from './components/ConsultaSeguimentoStatusRespondendoIcon'
import { ConsultaSeguimentoPergunta02Model } from './perguntas/consulta-seguimento-pergunta-02/model-consultaSeguimentoPergunta02'
import { ConsultaSeguimentoPergunta04Model } from './perguntas/consulta-seguimento-pergunta-04/model-consultaSeguimentoPergunta04'
import { ConsultaSeguimentoPergunta06Model } from './perguntas/consulta-seguimento-pergunta-06/model-consultaSeguimentoPergunta06'
import { ConsultaSeguimentoPergunta07Model } from './perguntas/consulta-seguimento-pergunta-07/model-consultaSeguimentoPergunta07'
import { ConsultaSeguimentoPergunta08Model } from './perguntas/consulta-seguimento-pergunta-08/model-consultaSeguimentoPergunta08'
import { ConsultaSeguimentoPergunta13Model } from './perguntas/consulta-seguimento-pergunta-13/model-consultaSeguimentoPergunta13'
import { ConsultaSeguimentoPergunta15Model } from './perguntas/consulta-seguimento-pergunta-15/model-consultaSeguimentoPergunta15'
import { ConsultaSeguimentoPergunta17Model } from './perguntas/consulta-seguimento-pergunta-17/model-consultaSeguimentoPergunta17'

export const CONSULTA_SEGUIMENTO_URL_MODAL = '/entrevista-seguimento'

export enum ConsultaSeguimentoModalTab {
  SELECAO = 'SELECAO',
  APLICACAO = 'APLICACAO',
  RESULTADO = 'RESULTADO',
}

export enum PassouFalhouEnum {
  PASSOU = 'PASSOU',
  FALHOU = 'FALHOU',
}

export enum ConsultaSeguimentoResultadoEnum {
  RASTREAMENTO_POSITIVO = 'RASTREAMENTO_POSITIVO',
  RASTREAMENTO_NEGATIVO = 'RASTREAMENTO_NEGATIVO',
}

export enum ConsultaSeguimentoPerguntaStatusEnum {
  NAO_DISPONIVEL = 'NAO_DISPONIVEL',
  DISPONIVEL = 'DISPONIVEL',
  RESPONDENDO = 'RESPONDENDO',
  RESPONDENDO_PASSOU = 'RESPONDENDO_PASSOU',
  RESPONDENDO_FALHOU = 'RESPONDENDO_FALHOU',
  FINALIZADO_PASSOU = 'FINALIZADO_PASSOU',
  FINALIZADO_FALHOU = 'FINALIZADO_FALHOU',
}

export enum ConsultaSeguimentoSelectionMode {
  AUTOMATICO = 'AUTOMATICO',
  MANUAL = 'MANUAL',
}

export interface ConsultaSeguimentoFieldModel {
  aplicacao: ConsultaSeguimentoAplicacaoModel
  perguntasSelecionadas: MChatPerguntaEnum[]
  selectionMode: ConsultaSeguimentoSelectionMode
  resultado?: ConsultaSeguimentoResultadoEnum
}

export type ConsultaSeguimentoAplicacaoItemModel = {
  resultado?: PassouFalhouEnum
  status: ConsultaSeguimentoPerguntaStatusEnum
}

export type ConsultaSeguimentoAplicacaoModel = Partial<{
  [MChatPerguntaEnum.PERGUNTA_01]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_02]: ConsultaSeguimentoPergunta02Model
  [MChatPerguntaEnum.PERGUNTA_03]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_04]: ConsultaSeguimentoPergunta04Model
  [MChatPerguntaEnum.PERGUNTA_05]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_06]: ConsultaSeguimentoPergunta06Model
  [MChatPerguntaEnum.PERGUNTA_07]: ConsultaSeguimentoPergunta07Model
  [MChatPerguntaEnum.PERGUNTA_08]: ConsultaSeguimentoPergunta08Model
  [MChatPerguntaEnum.PERGUNTA_09]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_10]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_11]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_12]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_13]: ConsultaSeguimentoPergunta13Model
  [MChatPerguntaEnum.PERGUNTA_14]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_15]: ConsultaSeguimentoPergunta15Model
  [MChatPerguntaEnum.PERGUNTA_16]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_17]: ConsultaSeguimentoPergunta17Model
  [MChatPerguntaEnum.PERGUNTA_18]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_19]: ConsultaSeguimentoAplicacaoItemModel
  [MChatPerguntaEnum.PERGUNTA_20]: ConsultaSeguimentoAplicacaoItemModel
}>

export const ConsultaSeguimentoPerguntaStatusMap: Record<
  ConsultaSeguimentoPerguntaStatusEnum,
  { icon: React.ReactNode; label?: React.ReactNode }
> = {
  NAO_DISPONIVEL: {
    icon: <Icon icon='questionMarkFilled' fill='disabled' size={1} />,
  },
  DISPONIVEL: {
    icon: <Icon icon='questionMarkFilled' fill='secondary' size={1} />,
    label: <ConsultaSeguimentoPerguntaStatusLabel label='Pronta para responder' />,
  },
  RESPONDENDO: {
    icon: <ConsultaSeguimentoStatusRespondendoIcon />,
    label: <ConsultaSeguimentoPerguntaStatusLabel label='Continue respondendo' />,
  },
  RESPONDENDO_PASSOU: {
    icon: <Icon icon='checkCircleFilled' fill='success' size={1} />,
    label: <ConsultaSeguimentoPerguntaStatusTag type={ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU} />,
  },
  RESPONDENDO_FALHOU: {
    icon: <Icon icon='timesFilled' fill='danger' size={1} />,
    label: <ConsultaSeguimentoPerguntaStatusTag type={ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU} />,
  },
  FINALIZADO_PASSOU: {
    icon: <Icon icon='checkCircleFilled' fill='success' size={1} />,
    label: (
      <ConsultaSeguimentoPerguntaStatusLabel label='Passou' status={ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU} />
    ),
  },
  FINALIZADO_FALHOU: {
    icon: <Icon icon='timesFilled' fill='danger' size={1} />,
    label: (
      <ConsultaSeguimentoPerguntaStatusLabel label='Falhou' status={ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU} />
    ),
  },
}

export const ConsultaSeguimentoResultadoMap: Record<
  ConsultaSeguimentoResultadoEnum,
  { title: string; encaminhamento: string; icon: IconImage }
> = {
  RASTREAMENTO_NEGATIVO: {
    title: 'Rastreamento Negativo',
    encaminhamento:
      'Nenhuma outra medida é necessária, a não ser que a vigilância indique risco de TEA. A criança deverá fazer a triagem novamente em futuras consultas de rotina.',
    icon: 'infoCircleFilled',
  },
  RASTREAMENTO_POSITIVO: {
    title: 'Rastreamento Positivo',
    encaminhamento:
      'É altamente recomendado que a criança seja encaminhada para a intervenção precoce e testagem diagnóstica o mais breve possível.',
    icon: 'exclamationTriangleFilled',
  },
}

export const ConsultaSeguimentoPassouFalhouMap: Record<PassouFalhouEnum, { title: string }> = {
  FALHOU: {
    title: 'Falhou',
  },
  PASSOU: {
    title: 'Passou',
  },
}
